import { formNames } from '@wkda/carlead-creation-form';
import { ANCHOR, AnchorStateProvider, Wizard, usePageData } from '@wkda/funnel-components';
import { findInput, getAllInputs } from '@wkda/funnel-utils';
import * as React from 'react';
import { Field } from 'react-final-form';
import { usePersistDecorator } from '../formCache';
import { useCarleadConflicts } from '../hooks/useCarleadConflicts';
import { useCreateCarlead } from '../hooks/useDataHooks/useCreateSelfEvaluation';

function _CarleadWizard(_ref) {
  let {
    children,
    carleadForm,
    options,
    submitHandler,
    topContent,
    bottomContent,
    machineService
  } = _ref;
  const {
    mutateAsync: createCarlead
  } = useCreateCarlead();
  const persistDecorator = usePersistDecorator();
  const {
    getSubmissionErrors,
    setErrors
  } = useCarleadConflicts();

  function onSubmitHandler(values, currentStep, isLastStep, formApi) {
    let promise = Promise.resolve({});
    const payload = carleadForm.mapValuesToPayload({}, values);

    if (isLastStep) {
      promise = submitHandler ? submitHandler({
        payload,
        extraParams: {
          step: currentStep + 1,
          formValues: values,
          isLastStep,
          machineService,
          formApi,
          carleadForm
        },
        response: undefined
      }) : //@ts-expect-error
      createCarlead(payload);
    }

    return promise;
  }

  function validate(currentStep, values) {
    return carleadForm.validateStep(currentStep, values);
  }

  function onValidationErrorHandler(_ref2, _ref3, errorsPerPage) {
    let {
      getState
    } = _ref2;
    let {
      currentStep
    } = _ref3;
    carleadForm.lifecycleHooks.onValidationError({
      errors: getState().errors,
      values: getState().values
    });
    onFocusHandler(getState().errors, currentStep, errorsPerPage);
  }

  function onSubmitSuccessHandler(step, isLastStep, response, setStep, values) {
    var _response$car;

    carleadForm.lifecycleHooks.onStepSubmitSuccess({
      step,
      isLastStep,
      carleadHash: response === null || response === void 0 ? void 0 : (_response$car = response.car) === null || _response$car === void 0 ? void 0 : _response$car.hash,
      setStep,
      response,
      values
    });
  }

  function onSubmitErrorHandler(step, isLastStep, e, setStep) {
    setErrors(e);
    return getSubmissionErrors(e);
  } //comes from the server initial page data extracted from WKDA cookie


  const {
    latestCIDchannel
  } = usePageData();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AnchorStateProvider, {
    stepAnchor: ANCHOR,
    enableStepAnchor: options === null || options === void 0 ? void 0 : options.enableStepAnchor
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-wizard"
  }, /*#__PURE__*/React.createElement(Wizard, {
    validate: validate,
    totalSteps: 1,
    getErrorsPerStep: carleadForm.validateAllSteps,
    initialValues: {},
    onSubmit: onSubmitHandler,
    onValidationError: onValidationErrorHandler,
    onSubmitSuccess: onSubmitSuccessHandler,
    onSubmitError: onSubmitErrorHandler,
    onBeforeSubmit: (formAPI, _ref4) => {
      let {
        setInitialValues
      } = _ref4;
      const {
        values,
        invalid
      } = formAPI.getState();

      if (!invalid) {
        setInitialValues(values);
      }
    },
    parseResponse: (_, values) => values,
    topContent: topContent,
    bottomContent: bottomContent,
    decorators: [persistDecorator.persistDecorator]
  }, children, /*#__PURE__*/React.createElement(Field, {
    name: formNames.latestCIDchannel,
    type: "hidden",
    component: "input",
    initialValue: latestCIDchannel
  })))));
}

export const CarleadWizard = /*#__PURE__*/React.memo(_CarleadWizard);

function onFocusHandler() {
  var _findInput;

  let errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let currentStep = arguments.length > 1 ? arguments[1] : undefined;
  let errorsPerPage = arguments.length > 2 ? arguments[2] : undefined;
  let stepWithErrors = errorsPerPage.findIndex(i => {
    return Object.keys(i).length > 0;
  });
  const firstErrorKey = Object.keys(errorsPerPage[stepWithErrors] || {})[0];
  const sameSection = stepWithErrors === currentStep;
  const foundElement = (_findInput = findInput(getAllInputs(), errors)) !== null && _findInput !== void 0 ? _findInput : getElement(firstErrorKey);

  if (foundElement) {
    setTimeout(() => {
      if (typeof foundElement.focus === 'function') {
        foundElement.focus({
          preventScroll: true
        });
      }

      foundElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }, sameSection ? 0 : 1000);
  }
}

function getElement(element) {
  return document.getElementById(element) || document.getElementsByName(element)[0] || document.getElementsByClassName(element)[0];
}